<template>
  <div class="hot-view-static" id="app">
    <PublicResourceHeader @register="onRegister" />
    <PublicResourceTemplace @register="onRegister">
      <gjxxList :listObj="listObj" />
    </PublicResourceTemplace>
    <FixedSuspension v-if="!isHeadlessBrowser" @register="onRegister" />
    <GjxxFooter />
  </div>
</template>

<script>
import { isHeadlessBrowser, getLoginStatus } from "@/utils/common";
import PublicResourceHeader from "@/components/Hot/PublicResourceHeader";
import GjxxFooter from "@/components/Hot/Footer";
import FixedSuspension from "@/components/Hot/FixedSuspension";
import PublicResourceTemplace from "@/components/Hot/PublicResourceTemplace";
import gjxxList from "@/components/SeoOld/List";
import {userApiMemberSingleFindUserContent} from "@/services/gjxx";
import {CookieKeys,Cookies} from "@/utils/cookieKey";

export default {
  name: "hot",
  components: {
    PublicResourceHeader,
    GjxxFooter,
    FixedSuspension,
    PublicResourceTemplace,
    gjxxList,
  },
  data() {
    return {
      username: "",
      isHeadlessBrowser: false,
      isLoginStatus: false,
    };
  },
  computed: {
    listObj() {
      return this.$store.getters["hot/listObj"];
    },
  },
  created() {

  },
  mounted() {
    Cookies.set(CookieKeys.firstTC, 'more', {
      expires: 1,
      domain: ".qianlima.com",
    });
    this.isHeadlessBrowser = isHeadlessBrowser();
    this.isLoginStatus = getLoginStatus();
    if (this.isLoginStatus) {
      this.getUser();
    }

  },
  methods: {
  async  getUser(){
     const userInfo = await userApiMemberSingleFindUserContent().then(res=>res.data);
     this.$store.commit('basic/updateUserInfo',userInfo)
    },
    onRegister(){
      registOrLogin()
    }
  },

};
</script>

<style lang="scss">
.hot-view-static {
  background: #fff;
  font-size: 12px;
  color: #000;
}
</style>
